<template>
  <b-card title="Reporting API Link">
    <b-form-input disabled :value="link"></b-form-input>
    <b-alert :show="true" class="mt-4">
      This link may be used to retrieve stats by GET request. By default the report interval is grouped by day,
      and if no start date is given (in yyyy-mm-dd format) the current date is used.
    </b-alert>
  </b-card>
</template>

<script>
  import md5 from 'js-md5'
  export default {
    name: 'ReportApi',
    props: {
      cid: { required: true },
      mode: { required: true }
    },
    computed: {
      link () {
        let link = API.startsWith('http') ? API : 'http:' + API

        link += '/api/stats/get?companyid=' + this.cid
        link += '&type=' + this.mode
        link += '&key=' + md5(this.cid)

        link += '&stats=clears'
        if(this.mode === 'demand') {
          link += ',spend'
        } else {
          link += ',cost'
        }

        link += '&interval=day'
        link += '&start=&end='

        return link
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ReportApi.vue